'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _FormActions = require('MeetingsLib/redux/actions/FormActions');

var FormActions = _interopRequireWildcard(_FormActions);

var _UICardWrapper = require('UIComponents/card/UICardWrapper');

var _UICardWrapper2 = _interopRequireDefault(_UICardWrapper);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _SkeletonDurationPicker = require('MeetingsLib/components/schedule/duration/SkeletonDurationPicker');

var _SkeletonDurationPicker2 = _interopRequireDefault(_SkeletonDurationPicker);

var _DurationPicker = require('MeetingsLib/components/schedule/duration/DurationPicker');

var _DurationPicker2 = _interopRequireDefault(_DurationPicker);

var _SkeletonTimePicker = require('MeetingsLib/components/schedule/time/SkeletonTimePicker');

var _SkeletonTimePicker2 = _interopRequireDefault(_SkeletonTimePicker);

var _TimePicker = require('MeetingsLib/components/schedule/time/TimePicker');

var _TimePicker2 = _interopRequireDefault(_TimePicker);

var _StepButtonsFooter = require('MeetingsLib/components/page/StepButtonsFooter');

var _StepButtonsFooter2 = _interopRequireDefault(_StepButtonsFooter);

var _UserProfile = require('MeetingsBase/models/UserProfile');

var _UserProfile2 = _interopRequireDefault(_UserProfile);

var _Branding = require('MeetingsBase/models/Branding');

var _Branding2 = _interopRequireDefault(_Branding);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimeOptionsSection = _react2.default.createClass({
  displayName: 'TimeOptionsSection',

  propTypes: {
    branding: _react.PropTypes.instanceOf(_Branding2.default).isRequired,
    compact: _react.PropTypes.bool.isRequired,
    isFetchingPublicAvailability: _react.PropTypes.bool.isRequired,
    goToPreviousStep: _react.PropTypes.func,
    profile: _react.PropTypes.instanceOf(_UserProfile2.default).isRequired,
    resetEventDateTime: _react.PropTypes.func.isRequired
  },

  handleGoToPreviousStep: function handleGoToPreviousStep() {
    var _props = this.props,
        resetEventDateTime = _props.resetEventDateTime,
        goToPreviousStep = _props.goToPreviousStep;


    resetEventDateTime();
    goToPreviousStep();
  },
  renderTimePicker: function renderTimePicker() {
    var _props2 = this.props,
        branding = _props2.branding,
        compact = _props2.compact,
        isFetchingPublicAvailability = _props2.isFetchingPublicAvailability,
        profile = _props2.profile;


    if (isFetchingPublicAvailability) {
      return _react2.default.createElement(_SkeletonTimePicker2.default, null);
    }

    return _react2.default.createElement(_TimePicker2.default, { branding: branding, compact: compact, profile: profile });
  },
  renderDurationPicker: function renderDurationPicker() {
    if (this.props.isFetchingPublicAvailability) {
      return _react2.default.createElement(_SkeletonDurationPicker2.default, null);
    }
    return _react2.default.createElement(_DurationPicker2.default, null);
  },
  renderStepButtonsFooter: function renderStepButtonsFooter() {
    var compact = this.props.compact;


    if (!compact) {
      return null;
    }

    return _react2.default.createElement(_StepButtonsFooter2.default, { goToPreviousStep: this.handleGoToPreviousStep });
  },
  render: function render() {
    return _react2.default.createElement(
      _UICardWrapper2.default,
      { className: 'p-all-8 height-100 m-bottom-0' },
      _react2.default.createElement(
        _UIFlex2.default,
        { direction: 'column', align: 'center', className: 'height-100' },
        this.renderDurationPicker(),
        this.renderTimePicker(),
        this.renderStepButtonsFooter()
      )
    );
  }
});

exports.default = (0, _reactRedux.connect)(null, FormActions)(TimeOptionsSection);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/sections/TimeOptionsSection.js
// module id = 223
// module chunks = 0